import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.cartBaseUrl);
import axios from 'axios';

export default {
  getMatchResult: params => {
    /**
     * @desc 【智能采购】匹配结果分页查询接口
     * @url http://mock.qa.91jkys.com/project/199?moduleId=945&interfaseId=10087
     */
    return request.post(
      // `http://127.0.0.1:3000/mock/11/share-mall-gateway-purchase/1.0/query_purchase_list_match_result`,
      `/api/share-mall-gateway-purchase/1.0.0/query_purchase_list_match_result`,
      params
    );
  },
  getMathInfo: params => {
    /**
     * @desc 【智能采购】匹配信息查询
     * @url http://mock.qa.91jkys.com/project/199?moduleId=945&interfaseId=10088
     */
    return request.get(
      // `http://127.0.0.1:3000/mock/11/share-mall-gateway-purchase/1.0/query_purchase_list_match_info`,
      `/api/share-mall-gateway-purchase/1.0.0/query_purchase_list_match_info`,
      { ...params, handleError: true }
    );
  },
  reset_purchase_list_match: params => {
    /**
     * @desc 【智能采购】重置采购清单匹配
     * @url http://mock.qa.91jkys.com/project/199?moduleId=945&interfaseId=10089
     */
    return request.get(
      // `//mock.qa.91jkys.com/api/project/mock/199/share-mall-gateway-purchase/1.0/reset_purchase_list_match`,
      `/api/share-mall-gateway-purchase/1.0.0/reset_purchase_list_match`,
      { ...params, handleError: true }
    );
  },
  h5Upload: params => {
    /**
     * @desc 【上传图片
     */
    return request.post(`/api/file/1.0/h5_upload`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }); // 购物车展示
  },
  purchase_list_match: params => {
    /**
     * @desc 【智能采购】导入采购清单接口
     */
    return request.post(
      // `http://127.0.0.1:3000/mock/11/share-mall-gateway-purchase/1.0/purchase_list_match`,
      `/api/share-mall-gateway-purchase/1.0.0/purchase_list_match`,
      params
    ); // 购物车展示
  }
};
